import * as XLSX from 'xlsx';
import { DayAgoPipe } from '../../shared/day-ago.pipe';
import { Component, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { AuthService } from '../../auth/auth.service';
import { UserDataService } from '../../features/user-data.service';

@Component({
  selector: 'app-search-combo',
  templateUrl: './search-combo.component.html',
  styleUrls: ['./search-combo.component.css']
})
export class SearchComboComponent implements OnInit, OnChanges {
  status="";
  users:any;
  userskeys:any;
  detail=new Subject();//the detail of a key data will be send to patent detail
  usersForRender:any; //cut the inventors part render purposes
  error="";
  token="";
  record:string="";
  userSubs!:Subscription;
  userWithToken:any;
  searchText:any;
  today=Date.now();
  oneDay = 24*60*60*1000;
  paintRows:any;
  lastStatus:any;
  visible=false;
  users1:any;

  counter=0;
  counterResult=0;

  countryName="";
  registrationYear="";
  applicationYear="";
  visibleSearch=false;
  switch=false;
  users1Reverse:any;

  visDoc=true;
  visInvName=true;
  visInvDate=true;
  visStatus=true;
  visAttorney=true;
  visTRStatus=true;
  visTRReg=true;
  visTRApp=true;
  visLastUpdate=true;
  visOwner=true;
  visInventor=true;
  visPatentRec=true;

  hideAttorney=false;


result:any;
searchAttorneyName="";
searchPatentType="";
searchPatentCountry="";
searchPatStatus="";
searchInvRight="";
searchInventorName="";
searchCompanyName="";
recData:any;
applicationNo="";
publicationNo="";

invDecStartDate ="1900-05-03";
invDecEndDate = "2100-11-01";

patAppStartDate ="1900-05-03";
patAppEndDate = "2100-11-01";

patLastStatusStartDate ="1900-05-03";
patLastStatusEndDate = "2100-11-01";

  constructor(private userData:UserDataService, private user:AuthService, private route:Router,private activatedRoute:ActivatedRoute) {

   }

   ngOnInit(): void {
    this.token=this.user.token;

    this.userData.fetchUsers(this.token).subscribe(
      (res: any) => {
       this.visible=true;
       if (!res) {
         this.record="Buluş Bulunamadı";
         alert("Buluş Bulunamadı. Sisteme ilk kez giriş yapıyorsanız buluş eklemeden önce veri merkezi sekmesi üzerinden sırası ile Şirket Kaydı, Buluşçu Kaydı ve Patent Vekili kaydını girmeniz gerekmektedir.")
       } else {

       console.log(res);
       this.userWithToken=res;
       this.users = Object.keys(res).map((key) =>
     { return res[key] });
       console.log(this.users)

       this.recData = Object.keys(res).map((key) =>
       {   return res[key] });
       this.users1 = Object.keys(res).map((key) =>
       {   res[key][0].status=res[key][0].status.slice(-1)[0];

          return res[key] });





       this.userskeys= Object.keys(res).map((key) =>
       { return (key) });
       /*this.paintRows=Object.keys(res).map((key) =>
       { return res[key][0].status.slice(-1)[0].date });*/
       this.paintRows=Object.keys(res).map((key) =>
       { return res[key][0].status.date });
      /* this.lastStatus=Object.keys(res).map((key) =>
       { return res[key][0].status.slice(-1)[0] });*/
       /*this.users.status={};
       this.users.status=Object.keys(res).map((key) =>
       { return res[key][0].status.slice(-1)[0] });*/
       //console.log(this.users1,this.userskeys,this.paintRows);
       this.result=this.users;
       this.recData=this.users;
       console.log(this.result,this.recData);
       this.userData.setAttorneyLogin();
       this.userData.checkAttorney();
       this.hideAttorney=this.userData.ifAttorney;
       console.log(this.hideAttorney);
       if (typeof this.userData.attorneyName != 'undefined'){ this.searchAttorneyName =(this.userData.attorneyName);}

       console.log(this.searchAttorneyName);
       console.log(this.result);
       this.submit();
        console.log(this.result);

       this.record=""
     }},err=>this.error=(err.statusText)
   );




    }
    ngOnChanges(): void {
      this.token=this.user.token;
      this.userData.fetchUsers(this.token).subscribe(
        (res: any) => {
         this.visible=true;
         if (!res) {
           this.record="Buluş Bulunamadı"
         } else {

         //console.log(res);
         this.userWithToken=res;

         this.users = Object.keys(res).map((key) =>
         {   return res[key] });
         this.users1 = Object.keys(res).map((key) =>
         {   res[key][0].status=res[key][0].status.slice(-1)[0];
            return res[key] });

         this.userskeys= Object.keys(res).map((key) =>
         { return (key) });

         this.paintRows=Object.keys(res).map((key) =>
         { return res[key][0].status.date });




         this.record=""
       }},err=>this.error=(err.statusText)
     );

     }


    searchSwitch() {this.switch=!this.switch;
      this.registrationYear="";
    this.applicationYear="";this.countryName="";
    this.searchText=null}
    checkVisDoc(){return this.visDoc}
    checkVisInvName(){return this.visInvName}
    checkVisInvDate() {return this.visInvDate}
    checkVisStatus() {return this.visStatus}

    checkVisAttorney(){return this.visAttorney}
    checkVisTRStatus(){return this.visTRStatus}
    checkVisTRReg(){return this.visTRReg}
    checkVisTRApp(){return this.visTRApp}
    checkVisLastUpdate(){return this.visLastUpdate}
    checkvisOwner(){return this.visOwner}
    checkvisInventor(){return this.visInventor}
    checkvisPatentRec(){return this.visPatentRec}





    inventionDetails(i:number, docNo:string){

      this.route.navigate(['patentList/',docNo]);
      //console.log(this.detail);
      this.userData.getKey(this.userskeys[i]);

     }
    redirectTo(uri:string){
      this.route.navigateByUrl('/', {skipLocationChange: true}).then(()=>
      this.route.navigate([uri]));
   }
   fileName= 'BuluşKayıtları.xlsx';

   exportexcel(): void
 {
   /* pass here the table id */
   let element = document.getElementById('excel-table');
   const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

   /* generate workbook and add the worksheet */
   const wb: XLSX.WorkBook = XLSX.utils.book_new();
   XLSX.utils.book_append_sheet(wb, ws, 'Buluş Bilgileri');

   /* save to file */
   XLSX.writeFile(wb, this.fileName);

 }
 inventionDateSearch(){
  console.log (this.result.length);
  for (let i=0; i<this.result.length; i++){
    if(this.result[i].length>0) {
    console.log(this.result[i][0].inventionDate)
      if (this.result[i][0].inventionDate<this.invDecStartDate || this.result[i][0].inventionDate>this.invDecEndDate) {
        this.result[i]=[];
        // (this.result.splice(i, 1));
      //  i--;
      }
      else {}
    }
  }
 }
 patentTypeSearch(){
  console.log (this.result.length);
  for (let i=0; i<this.result.length; i++){
    if(this.result[i].length>0) {
    let counter=0;
    if (this.result[i][0].hasOwnProperty('patentInfo')){
    for (let j=0; j<this.result[i][0].patentInfo.length; j++){

      //console.log(this.result[i][0].patentInfo[j].patentStatus.slice(-1)[0].type);
      console.log(this.result[i][0].patentInfo[j].patentStatus[0].status[1] , this.patAppStartDate);
      if (((this.result[i][0].patentInfo[j].patentStatus.slice(-1)[0].type)==(this.searchPatentType) || this.searchPatentType=="")
      && ((this.result[i][0].patentInfo[j].patentCountry)==(this.searchPatentCountry) || this.searchPatentCountry=="")
      && ((this.result[i][0].patentInfo[j].patentStatus[0].status[1]>this.patAppStartDate && this.result[i][0].patentInfo[j].patentStatus[0].status[1]<this.patAppEndDate))
       ) {

        counter++;
      }
      else {}
    }
    if(counter==0) {(this.result[i]=[]);
      i--;}
  } else {if ((this.searchPatentType!="" || this.searchPatentCountry!="")){(this.result[i]=[]);
    i--;}}
      /* if (this.result[i][0].AttorneyData[0].name.includes(this.searchAttorneyName) || this.searchAttorneyName=="") {

        }
        else {(this.result.splice(i, 1));
          i--;} */
    }}

    }

attorneySearch(){
  console.log (this.result);
  let counter=0;
  if (this.result.length>0) {
  for (let i=0; i<this.result.length; i++){
    counter=0;

    if(this.result[i].length>0) {
//console.log(this.result[i][0].AttorneyData[0].name,this.searchAttorneyName)
if(this.result[i][0].hasOwnProperty("AttorneyData")){
  for (let j=0; j<this.result[i][0].AttorneyData.length; j++){
       if (this.result[i][0].AttorneyData[j].name.includes(this.searchAttorneyName) || this.searchAttorneyName=="") {
        counter++;
        console.log("yes")
        }
        else {console.log("no")}}
        if(counter==0) {(this.result[i]=[]);
         }}  else {if(this.searchAttorneyName!=""){this.result[i]=[]}}
        }
        counter=0;
  }}


    console.log (this.result.length);
    }
    inventorSearch(){

      let counter=0;
      if (this.result.length>0) {
      for (let i=0; i<this.result.length; i++){
        if(this.result[i].length>0) {
        counter=0;

        for (let j=0; j<this.result[i][0].inventorData.length; j++) {

           if (this.result[i][0].inventorData[j].name.includes(this.searchInventorName) || this.searchInventorName=="") {
            counter++;

            }
            else {
             }
        }
        if(counter==0) {(this.result[i]=[]);
          i--;}}  }}

        console.log (this.result.length,counter);
        }
        companySearch(){  let counter=0;
          if (this.result.length>0) {
          for (let i=0; i<this.result.length; i++){
            console.log(this.result[i].length);
            counter=0;
if(this.result[i].length>0) {
            for (let j=0; j<this.result[i][0].CompanyData.length; j++) {

               if (this.result[i][0].CompanyData[j].name.includes(this.searchCompanyName) || this.searchCompanyName=="") {
                counter++;

                }
                else {
                 }
            }
            if(counter==0) {(this.result[i]=[]);
              i--;}} } }

            console.log (this.result.length,counter);}
    inventionRightSearch(){
      console.log (this.result.length);
      for (let i=0; i<this.result.length; i++){
        let counter=0;
        if(this.result[i].length>0) {
           if (this.result[i][0].status.status.includes(this.searchInvRight) || this.searchInvRight=="") {
            counter++;
            }
            else {
              (this.result[i]=[]);
              }}
        }
        console.log (this.result.length);
        }
      publicationNumberSearch() {
        console.log (this.result.length);
        for (let i=0; i<this.result.length; i++){
          if(this.result[i].length>0) {
          let counter=0;
          if (this.result[i][0].hasOwnProperty('patentInfo')){
          for (let j=0; j<this.result[i][0].patentInfo.length; j++){
            if(this.result[i][0].patentInfo[j].hasOwnProperty('patentPublicationNumber')){
            //console.log(this.result[i][0].patentInfo[j].patentStatus.slice(-1)[0].type);
            console.log(this.result[i][0].patentInfo[j].patentPublicationNumber );
            if ((this.result[i][0].patentInfo[j].patentPublicationNumber.includes( this.publicationNo) || this.publicationNo=="") ) {

              counter++;
            }
            else {}}else {if ((this.publicationNo!="")){(this.result[i]=[]);
              i--;}else{counter++;}}
          }
          if(counter==0) {(this.result[i]=[]);
           }
        } else {if ((this.publicationNo!="")){(this.result[i]=[]);
          i--;}}

          }}

          }
          applicationNumberSearch() {
            console.log (this.result.length);
            for (let i=0; i<this.result.length; i++){
              if(this.result[i].length>0) {
              let counter=0;
              if (this.result[i][0].hasOwnProperty('patentInfo')){
              for (let j=0; j<this.result[i][0].patentInfo.length; j++){

                //console.log(this.result[i][0].patentInfo[j].patentStatus.slice(-1)[0].type);
                console.log(this.result[i][0].patentInfo[j].patentNumber );
                if ((this.result[i][0].patentInfo[j].patentNumber.includes( this.applicationNo) || this.applicationNo=="") ) {

                  counter++;
                }
                else {}
              }
              if(counter==0) {(this.result[i]=[]);
               }
            } else {if ((this.applicationNo!="")){(this.result[i]=[]);
              }}

              }}

              }

 submit() {
  this.visible=!this.visible;
  this.result=this.recData;
  this.inventionDateSearch();
  this.companySearch();
  this.attorneySearch();
  this.publicationNumberSearch();
  this.applicationNumberSearch() ;
  this.inventorSearch();
  this.inventionRightSearch();
  this.patentTypeSearchTrial();
  let clone=  [...this.users];
  this.recData=clone;
  console.log(this.users);
  console.log(this.recData);
  console.log(this.result);
}
patentTypeSearchTrial(){
  console.log (this.result.length);
  for (let i=0; i<this.result.length; i++){
    if(this.result[i].length>0) {
    let counter=0;
    if (this.result[i][0].hasOwnProperty('patentInfo')){
    for (let j=0; j<this.result[i][0].patentInfo.length; j++){

      //console.log(this.result[i][0].patentInfo[j].patentStatus.slice(-1)[0].type);

      if (((this.result[i][0].patentInfo[j].patentType)==(this.searchPatentType) || this.searchPatentType=="")
      && ((this.result[i][0].patentInfo[j].patentCountry)==(this.searchPatentCountry) || this.searchPatentCountry=="")) {
        //console.log(this.result[i][0].patentInfo[j].patentStatus[0].status[1] , this.patAppStartDate);
        for (let k=0; k<this.result[i][0].patentInfo[j].patentStatus.length; k++){
          //console.log(this.result[i][0].patentInfo[j].patentStatus[0].status[1] , this.patAppStartDate);
          if (this.result[i][0].patentInfo[j].patentStatus[k].status[0]==this.searchPatStatus || this.searchPatStatus==""){
           console.log(this.result[i][0].inventionName)
      if((this.result[i][0].patentInfo[j].patentStatus[k].status[1]>this.patAppStartDate && this.result[i][0].patentInfo[j].patentStatus[k].status[1]<this.patAppEndDate))
      {counter++;}

      else {}


      }}}
      else {}
    }
    if(counter==0) {(this.result[i]=[]);
      i--;}
  } else {if ((this.searchPatentType!="" || this.searchPatentCountry!="" ||  this.searchPatStatus!="")){(this.result[i]=[]);
    i--;}}
      /* if (this.result[i][0].AttorneyData[0].name.includes(this.searchAttorneyName) || this.searchAttorneyName=="") {

        }
        else {(this.result.splice(i, 1));
          i--;} */
    }}

    }

}

